import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TabStripScrollingDirective } from '@app/shared/directives/kendohelpers/tabstrip-scrolling.directive';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { ProjectTeamFracFleetsComponent } from '../project-team-frac-fleets/project-team-frac-fleets.component';
import { ProjectTeamRigsComponent } from '../project-team-rigs/project-team-rigs.component';
import { ProjectTeamComponent } from '../project-team/project-team.component';

@Component({
  selector: 'app-project-team-home',
  templateUrl: './project-team-home.component.html',
  styleUrls: ['./project-team-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ProjectTeamComponent,
    ProjectTeamFracFleetsComponent,
    ProjectTeamRigsComponent,
    TabStripModule,
    TabStripScrollingDirective,
  ],
})
export class ProjectTeamHomeComponent { }